const Reports = () => <div>Report page will be here</div>;

export default Reports;
